<template>
  <div
    class="pricing-table-section">
    <div
      v-for="pricing in fields"
      :key="pricing.name"
      class="pricing-table-section-row">
      <div class="pricing-table-section-row-left">
        <div class="pricing-table-section-name">
          {{ pricing.name }}
        </div>
        <div class="pricing-table-section-comment">
          {{ getComment(pricing) }}
        </div>
      </div>
      <div
        v-if="pricing.issuers"
        class="pricing-table-section-row-right">
        <div class="pricing-table-section-price">
          <ContractPrice :issuers="pricing.issuers"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ContractPrice from '@/modules/pricing/components/ContractPrice.vue';
import {
  ContractPricing,
  ContractPricingBody,
} from '@/services/requests/users/Users.types';

const { fields } = defineProps<{
  fields: ContractPricing;
  title?: string;
}>();

const { t } = useI18n();

function getComment(pricingItem: ContractPricingBody) {
  if (pricingItem.name === t('components.pricing.section.atm_fees')) return t('components.pricing.section.third_party_apply');
  return pricingItem.comment;
}

</script>

<style lang="scss" scoped>
.pricing {
  &-table {
    &-section {
      @apply mt-40;

      &-row {
        @apply flex justify-between items-center font-normal text-lg text-n-black-100 h-[58px] border-b border-solid border-b-gray-20;

        &:last-child {
          @apply border-0;
        }

        &-left {
          @apply flex flex-col gap-4;
        }
      }

      &-title {
        @apply font-semibold text-xl text-text-black-100 mb-12;
      }

      &-comment {
        @apply text-base text-n-black-80;
      }

      &-price {
        @apply font-medium;
      }
    }
  }
}
</style>
